import {inject, injectable} from 'inversify';

import type {
  CoreClientFollowersListParams,
  CoreCoachFollowersListParams,
} from '../../../../../api/types/core/methods';
import type {FollowerModel} from '../../../../domain/Follower/Follower.model';
import type {FetchFollowersListByUserIdQuery} from '../FetchFollowersListByUserId.query';

import {apiRequest} from '../../../../../api/utils/apiRequest';
import {FollowerMapperJrpc} from '../../../../domain/Follower/mappers/Follower.mapper.jrpc';

@injectable()
export class FetchFollowersListByUserIdQueryJrpc
  implements FetchFollowersListByUserIdQuery
{
  constructor(
    @inject(FollowerMapperJrpc) private readonly mapper: FollowerMapperJrpc,
  ) {}

  async exec(
    props: FetchFollowersListByUserIdQuery.Props,
  ): Promise<FollowerModel[]> {
    const response = props.isForCoach
      ? await this.coach(props)
      : await this.client(props);

    return response.map(item => this.mapper.mapDataToModel(item));
  }

  private async client(
    props: FetchFollowersListByUserIdQuery.Props,
  ): Promise<FollowerMapperJrpc.ApiData[]> {
    const response = await apiRequest<CoreClientFollowersListParams>({
      method: 'client.followers.list',
      params: {
        query: [['coach_id', '==', props.userId]],
      },
    });

    return response._items;
  }

  private async coach(
    props: FetchFollowersListByUserIdQuery.Props,
  ): Promise<FollowerMapperJrpc.ApiData[]> {
    const response = await apiRequest<CoreCoachFollowersListParams>({
      method: 'coach.followers.list',
      params: {
        query: [['client_id', '==', props.userId]],
      },
    });

    return response._items;
  }
}
